import type { SectionOf } from './shared'

export default function StatsSection({ section }: { section: SectionOf<'stats'> }) {
  return (
    <>
      {section.heading && (
        <h2 className="text-3xl font-bold tracking-tight sm:text-4xl">{section.heading}</h2>
      )}
      <div className="mt-12 grid gap-10 sm:grid-cols-3">
        {section.items.map((s) => (
          <div key={s.label}>
            <p className="text-4xl font-bold tracking-tight">{s.figure}</p>
            <p className="mt-1 text-muted-foreground">{s.label}</p>
          </div>
        ))}
      </div>
      {section.footnote && (
        <p className="mt-10 text-lg text-muted-foreground">{section.footnote}</p>
      )}
    </>
  )
}
